"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
const app_1 = require("app");
class ConfigService {
    GetData() {
        this.config = this.config || app_1.AttrService.data(document.body, 'config');
        return this.config;
    }
    GetIPaperDomain() {
        const config = this.config || this.GetData();
        if (!config || !config.iPaperDomain) {
            return;
        }
        return config.iPaperDomain;
    }
    IsDeferOffscreenImagesEnabled() {
        const config = this.config || this.GetData();
        if (!config || !config.isDeferOffscreenImagesEnabled) {
            return false;
        }
        return config.isDeferOffscreenImagesEnabled;
    }
}
const service = new ConfigService();
exports.ConfigService = service;
